import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import {
  List,
  ListItem,
  ListItemText,
  Button,
  Snackbar,
  Alert,

} from "@mui/material";
import axios from "axios";
import DeleteIcon from "@mui/icons-material/Delete";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { CircularProgress } from '@mui/material';
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import { useAcademicYear } from "./AcademicYearContext";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function EventProductEdit({
  setopenEditComponent,
  EventId,
  SelectedEventissueProductId,
  SelectedEventName, data, EventDescription, SelectedEventStatusId, SelectedEventCategory, SelectedEventId

}) {

  console.log("recied props in edit component", EventId, SelectedEventissueProductId, SelectedEventName, SelectedEventStatusId, SelectedEventCategory, SelectedEventId)
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [product, setProduct] = useState([]);
  const [issueProductId, setIssueProductId] = useState(null);
  const [userId, setUserId] = useState();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("issue_product_details_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState({});
  const [validationErrors, setValidationErrors] = useState(false);
  const [currentQuantity, setCurrentQuantity] = useState({});
  const [markedForDelete, setMarkedForDelete] = useState([]);
  const [issuedStatusId, setIssuedStatusId] = useState(null);
  const [createdStatusId, setCreatedStatusId] = useState(null);
  const [openProduct, setOpenProduct] = useState(false);
  const [error, setError] = useState(""); // Error message state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchStaff, setSearchStaff] = useState("");
  const [searchResultsForStaff, setSearchResultsForStaff] = useState([]);
  const [staffName1, setStaffName1] = useState();
  const [staffId, setStaffId] = useState();
  const [openstaff, setOpenstaff] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(false); // Loading state
  const [needsReturn, setNeedsReturn] = useState(true)
  const [openNeedsReturn, setOpenNeedsReturn] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [allStaffData, setAllStaffData] = useState([]);
  const [indentId, setIndentId] = useState("");

  const [open, setOpen] = useState(false); // for dialog
  const [filteredProduct, setFilteredProduct] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]); // from search bar
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [eventIssueProductId, setEventIssueProductId] = useState(null);
  const [description, setDescription] = useState(EventDescription || '');
  const [productSearchError, setProductSearchError] = useState("");



  const navigate = useNavigate();
  const { academicYearId } = useAcademicYear();

  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);

  // useEffect(() => {
  //   if (SelectedEventStatusId === 1) {
  //     // For "Created" status - show existing description
  //     setDescription(EventDescription || '');
  //   } else {
  //     // For "Issued" or other status - start with empty description
  //     setDescription('');
  //   }
  // }, [EventDescription, SelectedEventStatusId]);


  useEffect(() => {
    setDescription(EventDescription || '');
  }, [EventDescription]);

  const handleCheckboxClick = async () => {
    try {
      const newNeedsReturnValue = !needsReturn; // Toggle the current value

      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/events/updateNeedsReturnEvent",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            issue_product_id: SelectedEventissueProductId,
            needs_return: newNeedsReturnValue, // Send toggled value
            updated_by: userId,
            updated_timestamp: new Date(),
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update data");

      const data = await response.json();
      console.log("Success:", data);

      setNeedsReturn(newNeedsReturnValue); // Update state with toggled value
    } catch (error) {
      console.error("Error:", error);
    }
    setOpenNeedsReturn(false);
  };


  // const handleProceed = () => {
  //     setOpenComponent(false);
  //     setOpenComponentCreateSale(false);


  // };

  const handleCloseProduct = () => {
    setOpenProduct(false);
  };

  const handleCloseNeedsReturn = () => {
    setOpenNeedsReturn(false);
  };

  const handleOpenNeedsReturn = () => {
    if (issueProductId) {
      setOpenNeedsReturn(true);
    }
  };

  const handleClosestaff = () => {
    setOpenstaff(false);
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } }

        );
        if (response.status === 200) {
          setUserId(response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);


  useEffect(() => {
    const fetchProducts = async () => {
      setLoadingProduct(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getsearchresult`
        );
        if (!response.ok) throw new Error("Failed to fetch products");
        const data = await response.json();
        setAllProducts(data);
        // setSearchResults([]); // initially show nothing
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoadingProduct(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    const filtered = allProducts.filter((row) =>
      searchTerms.every(
        (term) =>
          (row.product_id &&
            row.product_id.toString().toLowerCase().includes(term)) ||
          (row.product_name &&
            row.product_name.toLowerCase().includes(term)) ||
          (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
          (row.attribute_name &&
            row.attribute_name.toLowerCase().includes(term)) ||
          (row.attribute_value &&
            row.attribute_value.toLowerCase().includes(term)) ||
          (row.price && row.price.toString().toLowerCase().includes(term)) ||
          (row.quantity && row.quantity.toString().toLowerCase().includes(term))
      )
    );

    setSearchResults(filtered);
    console.log("serached results in filere ", filtered);
  }, [searchQuery, allProducts]);


  useEffect(() => {
    getProduct();
  }, []);

  useEffect(() => {
    console.log("EventId updated in CreateProduct:", EventId);
    if (EventId) {
      getProduct(); // ✅ Trigger API only after EventId is set
    }
  }, [EventId]);

  useEffect(() => {
    getProduct();
  }, [SelectedEventissueProductId, academicYearId]);

  useEffect(() => {
    getProduct();
  }, []);

  useEffect(() => {
    if (Array.isArray(tableData)) {
      // For "Created" status (status 1), filter existing products
      const filtered = tableData.filter(
        (item) => item.event_issue_product_status_id === 1
      );

      // ✅ For "Issued" status, show newly added products from tableData
      const newlyAddedProducts = tableData.filter(
        (item) => !item.event_issue_product_status_id || item.event_issue_product_status_id !== 1
      );

      // Combine based on status
      const finalData = SelectedEventStatusId === 1
        ? filtered  // Show only existing "Created" products
        : newlyAddedProducts;  // Show newly added products for "Issued"

      setFilteredProduct(finalData);

      // Set indent ID conditionally
      if (SelectedEventStatusId === 1) {
        setEventIssueProductId(SelectedEventissueProductId);
      } else if (newlyAddedProducts.length > 0 && newlyAddedProducts[0].event_issue_product_id) {
        setEventIssueProductId(newlyAddedProducts[0].event_issue_product_id);
      }

      console.log("Final Table Data:", finalData);
    }
  }, [tableData, SelectedEventStatusId, SelectedEventissueProductId]);


  const getProduct = async () => {
    if (SelectedEventStatusId !== 1) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/geteventproductbyid`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            issue_product_id: SelectedEventissueProductId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Fetched product data:", data);

      if (Array.isArray(data) && data.length > 0) {
        setProduct(data);
        setTableData(data);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };


  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleInput = () => {
    setOpenstaff(true);
  };

  const handleSearchForstaff = (event) => {
    setSearchStaff(event.target.value);
  };


  useEffect(() => {
    setDescription(EventDescription || '');
  }, [EventDescription]);


  const handleProductSelect = async (product) => {
    console.log("Selected product from search:", product);
    try {
      // Duplicate check in UI
      const isAlreadyAdded = tableData.some(
        (item) => item.product_id === product.product_id
      );
      if (isAlreadyAdded) {
        setError("This product is already added.");
        setSnackbarOpen(true);
        return;
      }

      // Stock check
      if (product.quantity <= 0) {
        setError("This product is out of stock.");
        setSnackbarOpen(true);
        return;
      }

      // Clear previous error for valid selection
      // setError("");
      setSnackbarOpen(false);

      // API call to insert
      const res = await axios.post(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/addeventSale`,
        {
          academicYearId: academicYearId,
          event_id: EventId,
          product_id: product.product_id,
          quantity: 1,
          return_quantity: 0,
          event_issue_product_decription: description,
          created_by: userId
        },
        { withCredentials: true }
      );

      if (!res.data || !res.data.event_issue_product_details_id) {
        throw new Error("Invalid response from server.");
      }

      setIndentId(tableData.event_issue_product_id);
      setTableData(prev => [...prev, res.data]);
      setSearchQuery("");
      setSearchResults([]);
      getProduct();
      setProductSearchError(""); // Clear any previous errors
    } catch (err) {
      console.error("Error adding product:", err);
      setError("This product is already added.");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    console.log("product searchReasult", allProducts);
  }, [allProducts]);


  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };


  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = () => {
    return filteredProduct.slice().sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });
  };

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleQuantityChange = async (
    salesDetailsId,
    value,
    maxQuantity,
    productId
  ) => {
    const numericValue = parseInt(value, 10);

    // Step 1: Validation checks
    if (value === "" || isNaN(numericValue)) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity is required and must be between 1 and ${maxQuantity}`,
      }));
      setSelectedQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: "",
      }));
      return;
    }

    if (numericValue < 1) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: "Quantity must be at least 1.",
      }));
      return;
    }

    if (numericValue > maxQuantity) {
      setValidationErrors((prev) => ({
        ...prev,
        [salesDetailsId]: `Quantity cannot exceed available stock.`,
      }));
      return;
    }

    // Step 2: Clear validation errors if all checks pass
    setValidationErrors((prev) => ({
      ...prev,
      [salesDetailsId]: null,
    }));

    // Step 3: Update the selected quantity in the local state
    setSelectedQuantity((prev) => ({
      ...prev,
      [salesDetailsId]: numericValue,
    }));

    try {
      // ✅ Correct fetch usage
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateEventIssueProductDetailQuantity`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            event_issue_product_details_id: salesDetailsId,
            quantity: numericValue,
            event_description: description

          }),
        }
      );




      if (!response.ok) {
        throw new Error("Failed to update sales data");
      }


      const result = await response.json();
      console.log("Update successful:", result);

      // Refresh product list
      getProduct();

      // Update local state
      setCurrentQuantity((prev) => ({
        ...prev,
        [salesDetailsId]: numericValue,
      }));

      // Optionally update total price
      // updateTotalPrice();
    } catch (error) {
      console.error("Error during update:", error);
    }
  };



  // SINGLE ROW DELETE (from icon)
  // SINGLE ROW DELETE (from icon) with toggle support
  const handleRowDeleteClick = (detailId) => {
    setMarkedForDelete((prev) => {
      if (prev.includes(detailId)) {
        // If already selected, remove it
        return prev.filter((id) => id !== detailId);
      } else {
        // If not selected, add it
        return [...prev, detailId];
      }
    });
  };


  const handleBatchDelete = () => {
    setOpen(true); // ✅ open confirmation dialog here
  };

  // Close dialog
  const handleClose = () => {
    setOpen(false);
  };

  // Delete confirmed
  const handleConfirmDelete = () => {
    handleDeleteProduct();
    setOpen(false);
  };
  // Replace your existing handleDeleteProduct function with this:

  const handleDeleteProduct = async () => {
    try {
      for (let detailId of markedForDelete) {
        const res = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/deleteEventIssueProductDetail`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ event_issue_product_details_id: detailId }),
          }
        );

        if (!res.ok) throw new Error("Delete failed");
      }

      // ✅ Remove from ALL relevant state arrays
      setTableData((prev) =>
        prev.filter(
          (item) => !markedForDelete.includes(item.event_issue_product_details_id)
        )
      );

      // ✅ ALSO remove from selectedProducts array
      setSelectedProducts((prev) =>
        prev.filter(
          (item) => !markedForDelete.includes(item.event_issue_product_details_id)
        )
      );

      // ✅ Clear selectedProduct if it's marked for deletion
      if (selectedProduct && markedForDelete.includes(selectedProduct.event_issue_product_details_id)) {
        setSelectedProduct(null);
      }

      setMarkedForDelete([]);
      setOpen(false);

      // Only refresh if needed for existing products
      if (SelectedEventStatusId === 1) {
        getProduct();
      }
    } catch (err) {
      console.error("Error deleting product:", err);
    }
  };
  const saveQuantity = async (detailId, quantity, salesDetailsId) => {

    console.log("insode save quanityt api");
    await fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateEventIssueProductDetailQuantity`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ event_issue_product_details_id: detailId, quantity, event_description: description })
    });

    console.log("api event description function");
    await fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateEventIssueDescription`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          event_issue_product_details_id: SelectedEventId,
          event_description: description

        }),
      }
    );
  };
 

 const handleOk = async () => {

     // ✅ Validation: Check if staff is selected but no products
  if (SelectedEventName && tableData.length === 0) {
    setProductSearchError("Please select product(s) before proceeding.");
    return;
  }

  try {
    console.log("handleOk function triggered, status:", SelectedEventStatusId);

    // ✅ Case 1: When status = 1 → run full save logic
    if (SelectedEventStatusId === 1) {
      console.log("Saving description and quantities (status = 1)");

      const issueProductIdToUse = eventIssueProductId || SelectedEventId;

      // ✅ Save description
      if (issueProductIdToUse) {
        await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateEventIssueDescription`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              event_issue_product_details_id: issueProductIdToUse,
              event_description: description.trim() === "" ? null : description,
              updated_by: userId,
              updated_timestamp: new Date(),
            }),
          }
        );
      }

      // ✅ Save all product quantities
      for (let item of filteredProduct) {
        if (item.event_issue_product_details_id && item.quantity) {
          await fetch(
            `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updateEventIssueProductDetailQuantity`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({
                event_issue_product_details_id: item.event_issue_product_details_id,
                quantity: item.quantity,
                updated_by: userId,
                updated_timestamp: new Date(),
              }),
            }
          );
        }
      }
    }

    // ✅ Case 2: When status = 2, 3, or 4 → only update description
    else if ([2, 3, 4].includes(SelectedEventStatusId)) {
      console.log("Updating description only (status = 2, 3, or 4)", SelectedEventissueProductId);
     
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/events/updatedescription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            issueProductId: eventIssueProductId,
            issue_description: description,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update description");
      }
    }

    // ✅ Close the edit component after all operations
    setopenEditComponent(false);
  } catch (error) {
    console.error("Error in handleOk:", error);
    // alert("Failed to save changes. Please try again.");
  }
};


  return (
    <div>
      <div className="main_title1">
        Event Name: {SelectedEventName} &nbsp;&nbsp; Event Category: {SelectedEventCategory}

      </div>
      <div>
        <TextField
          label="Description"
          multiline
          rows={2} // 1.5 is not a valid value; use whole numbers like 2
          variant="outlined"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{
            minWidth: 700,
            marginTop: "25px",
            "& .MuiOutlinedInput-root": {
              padding: "8px",
            },
            "& .MuiInputLabel-root": {
              color: "#484f53ff",
            },
          }}
        />

      </div>
      <div
        style={{
          margin: "20px 0",
          fontSize: 15,
          fontWeight: "bold",
          color: "#0A64A2",
          paddingTop: "0",
        }}
      >
        Indent ID:{" "}  {SelectedEventStatusId === 1 ? SelectedEventissueProductId : eventIssueProductId || ""}

      </div>

      <div className="create_search" >
        {/* Search Field and Proceed Button */}
        <div style={{ display: "flex" }}>
          <div className="create_search1" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <TextField
              sx={{ minWidth: 700, marginBottom: "4px" }}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={EventId ? handleSearchChange : handleInput} // Conditional onChange
              label={productSearchError ? productSearchError : "Product Search"}
              error={!!productSearchError}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {loadingProduct ? <CircularProgress size={18} /> : null}
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="sale-div">
            <div className="sale-delete-div">
              <Button
                variant="contained"
                color="primary"
                onClick={handleOk}
                className="sale-delete-btn"
              >
                OK
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBatchDelete}
                className="sale-delete-btn"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>



        {/* Search Results List */}
        {searchQuery.trim() !== "" && searchResults.length > 0 && (
          <List
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "0",
              width: 700,
            }}
          >
            {searchResults.map((product) => (
              <ListItem
                button
                key={product.product_id}
                onClick={() => handleProductSelect(product)}
              >
                <ListItemText primary={product.product_name} />
                <ListItemText primary={product.attribute_name} />
                <ListItemText primary={product.attribute_value} />
                <ListItemText primary={product.price} />
                <ListItemText primary={product.quantity} />
              </ListItem>
            ))}
          </List>
        )}
      </div>


      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 750 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <TableSortLabel
                  active={orderBy === "issue_product_details_id"}
                  direction={orderBy === "issue_product_details_id" ? order : "asc"}
                  onClick={() => handleSort("issue_product_details_id")}
                >
                  Sl.No</TableSortLabel></StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "product_name"}
                  direction={orderBy === "product_name" ? order : "asc"}
                  onClick={() => handleSort("product_name")}
                >
                  Product Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_name"}
                  direction={orderBy === "attribute_name" ? order : "asc"}
                  onClick={() => handleSort("attribute_name")}
                >
                  Attribute Name
                </TableSortLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "attribute_value"}
                  direction={orderBy === "attribute_value" ? order : "asc"}
                  onClick={() => handleSort("attribute_value")}
                >
                  Attribute Value{" "}
                </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center">

                Quantity{" "}

              </StyledTableCell>

              <StyledTableCell align="center">
                <TableSortLabel
                  active={orderBy === "quantity"}
                  direction={orderBy === "quantity" ? order : "asc"}
                  onClick={() => handleSort("quantity")}
                >
                  Quantity In Stock
                </TableSortLabel>
              </StyledTableCell>

              <StyledTableCell align="center"></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const isMarked = markedForDelete.includes(row.event_issue_product_details_id);

                return (
                  <StyledTableRow key={row.event_issue_product_details_id}>
                    <StyledTableCell align="center" className="table-cell-border">
                      {row.event_issue_product_details_id}
                      {isMarked && <div className="centered-red-line-store-purchase" />}
                    </StyledTableCell>

                    <StyledTableCell align="center" className="table-cell-border">
                      {row.product_name}
                      {isMarked && <div className="centered-red-line-store-purchase" />}
                    </StyledTableCell>

                    <StyledTableCell align="center" className="table-cell-border">
                      {row.attribute_name}
                      {isMarked && <div className="centered-red-line-store-purchase" />}
                    </StyledTableCell>

                    <StyledTableCell align="center" className="table-cell-border">
                      {row.attribute_value}
                      {isMarked && <div className="centered-red-line-store-purchase" />}
                    </StyledTableCell>

                    <StyledTableCell align="center" className="table-cell-border">
                      <div>
                        <input
                          type="number"
                          value={
                            selectedQuantity[row.event_issue_product_details_id] !== undefined
                              ? selectedQuantity[row.event_issue_product_details_id]
                              : row.quantity || 1
                          }
                          onChange={(e) =>
                            handleQuantityChange(
                              row.event_issue_product_details_id,
                              e.target.value,
                              row.stock,
                              row.product_id
                            )
                          }
                          style={{ width: "60px" }}
                        />
                        {validationErrors[row.event_issue_product_details_id] && (
                          <div style={{ color: "red", marginTop: "5px" }}>
                            {validationErrors[row.event_issue_product_details_id]}
                          </div>
                        )}
                      </div>
                      {isMarked && <div className="centered-red-line-store-purchase" />}
                    </StyledTableCell>

                    <StyledTableCell align="center" className="table-cell-border">
                      {row.stock}
                      {isMarked && <div className="centered-red-line-store-purchase" />}
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      style={{ lineHeight: "10px", padding: "5px" }}
                    >
                      <IconButton
                        color="black"
                        onClick={() =>
                          handleRowDeleteClick(row.event_issue_product_details_id)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        style={{ backgroundColor: "#0A64A2", color: "#fff" }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {/* 
         

          {/* Delete Confirmation Dialog */}

      <Dialog
        // open={open}
        // onClose={handleClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {markedForDelete.length > 0
              ? "Are you sure you want to delete this selected Product(s)?"
              : "Please select product(s) before deleting."}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {" "}
          {/* Center-align the buttons */}
          {markedForDelete.length > 0 ? (
            <Button
              variant="contained"
              // onClick={handleDeleteConfirm}
              className="no-btn"
            >
              Yes
            </Button>
          ) : (
            ""
          )}
          <Button
            variant="contained"
            // onClick={handleClose}
            autoFocus
            className="no-btn"
          >
            {markedForDelete.length > 0 ? "No" : "Ok"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {markedForDelete.length > 0
              ? "Are you sure you want to delete this selected Product(s)?"
              : "Please select product(s) before deleting."}
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {markedForDelete.length > 0 && (
            <Button
              variant="contained"
              onClick={handleConfirmDelete}
              sx={{
                backgroundColor: "#0A64A2",
                "&:hover": {
                  backgroundColor: "#084c7a", // slightly darker shade for hover
                },
              }}
            >
              Yes
            </Button>
          )}
          <Button
            variant="contained"
            onClick={() => {
              setMarkedForDelete([]); // ✅ Clear red line selection
              handleClose();          // ✅ Close dialog
            }}
            sx={{
              backgroundColor: "#0A64A2",
              "&:hover": {
                backgroundColor: "#084c7a", // same hover effect as Yes
              },
            }}
            autoFocus
          >
            {markedForDelete.length > 0 ? "No" : "Ok"}
          </Button>
        </DialogActions>

      </Dialog>


      {/* Product Selection Dialog */}
      <Dialog
        open={openProduct}
        onClose={handleCloseProduct}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Please select product(s) before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCloseProduct}
            autoFocus
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>



      {/* Needs Return Dialog */}
      <Dialog
        open={openNeedsReturn}
        onClose={handleCloseNeedsReturn}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {needsReturn
              ? `Are you sure you want to mark Indent Id ${SelectedEventissueProductId} returnable?`
              : `Are you sure you want to mark Indent Id ${SelectedEventissueProductId} non-returnable?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCheckboxClick}
            autoFocus
            className="no-btn"
          >
            Yes
          </Button>
          <Button
            variant="contained"
            onClick={handleCloseNeedsReturn}
            autoFocus
            className="no-btn"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for errors */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          // onClose={handleCloseSnackbar}
          severity="error"
          variant="filled"
        >
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
}
